import { createSlice } from '@reduxjs/toolkit';
import { setDefinitions } from '../../actions/SetDefinitions';
const initialState = {};
export const zigbeeNodeBindingTableSlice = createSlice({
    name: 'zigbee_node_binding_table',
    initialState,
    reducers: {
        zigbeeNodeBindingTableCleared() {
            return {};
        },
        zigbeeNodeBindingTableUpdated: (s, action) => {
            s[action.payload.node_id] = action.payload.binding_table;
        },
        zigbeeNodeBindingTableDeleted: (s, action) => {
            delete s[action.payload];
        },
        zigbeeNodeBindingTablesReplaced: (s, action) => {
            return action.payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(setDefinitions, (s, action) => {
            const newState = {};
            for (const zigbeeNode of action.payload.zigbee_nodes) {
                const bt = zigbeeNode.moved_to_own_slice_binding_table;
                if (bt !== undefined) {
                    newState[zigbeeNode.id] = bt;
                }
            }
            return newState;
        });
    },
});
export const { zigbeeNodeBindingTableCleared, zigbeeNodeBindingTableUpdated, zigbeeNodeBindingTableDeleted, zigbeeNodeBindingTablesReplaced, } = zigbeeNodeBindingTableSlice.actions;
export default zigbeeNodeBindingTableSlice.reducer;
